// extracted by mini-css-extract-plugin
export default {"CardAuth":"CardAuth_CardAuth__BpPRA","CardAuth__space":"CardAuth_CardAuth__space__kf+o4"};